/**
 * Created by user on 2020/5/11.
 */

export * from '@novel-segment/loader-line';
import load from '@novel-segment/loader-line';

export default load
